import { render, staticRenderFns } from "./ReDoska.vue?vue&type=template&id=d6332e98&scoped=true"
import script from "./ReDoska.vue?vue&type=script&lang=js"
export * from "./ReDoska.vue?vue&type=script&lang=js"
import style0 from "./ReDoska.vue?vue&type=style&index=0&id=d6332e98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6332e98",
  null
  
)

export default component.exports